@if (!editMode) {
  <div>
    <button mat-raised-button (click)="openDialog()" type="button"><mat-icon>search</mat-icon> Preview</button>
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="form-container">
    <textarea formControlName="{{ fieldConfig.name }}" matInput value="{{ data }}"></textarea>
  </mat-form-field>
}
